export default __webpack_public_path__ + "static/media/Country.cb1ed2a1.svg";